import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/math/base/assert/int32-is-even';
import __var_2__ from '@stdlib/math/base/assert/int32-is-odd';
import __var_3__ from '@stdlib/math/base/assert/is-composite';
import __var_4__ from '@stdlib/math/base/assert/is-coprime';
import __var_5__ from '@stdlib/math/base/assert/is-even';
import __var_6__ from '@stdlib/math/base/assert/is-finite';
import __var_7__ from '@stdlib/math/base/assert/is-finitef';
import __var_8__ from '@stdlib/math/base/assert/is-infinite';
import __var_9__ from '@stdlib/math/base/assert/is-infinitef';
import __var_10__ from '@stdlib/math/base/assert/is-integer';
import __var_11__ from '@stdlib/math/base/assert/is-nan';
import __var_12__ from '@stdlib/math/base/assert/is-nanf';
import __var_13__ from '@stdlib/math/base/assert/is-negative-integer';
import __var_14__ from '@stdlib/math/base/assert/is-negative-zero';
import __var_15__ from '@stdlib/math/base/assert/is-negative-zerof';
import __var_16__ from '@stdlib/math/base/assert/is-nonnegative-integer';
import __var_17__ from '@stdlib/math/base/assert/is-nonpositive-integer';
import __var_18__ from '@stdlib/math/base/assert/is-odd';
import __var_19__ from '@stdlib/math/base/assert/is-positive-integer';
import __var_20__ from '@stdlib/math/base/assert/is-positive-zero';
import __var_21__ from '@stdlib/math/base/assert/is-positive-zerof';
import __var_22__ from '@stdlib/math/base/assert/is-prime';
import __var_23__ from '@stdlib/math/base/assert/is-probability';
import __var_24__ from '@stdlib/math/base/assert/is-safe-integer';
import __var_25__ from '@stdlib/math/base/assert/uint32-is-pow2';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name isEvenInt32
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/int32-is-even}
*/
setReadOnly( ns, 'isEvenInt32', __var_1__);

/**
* @name isOddInt32
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/int32-is-odd}
*/
setReadOnly( ns, 'isOddInt32', __var_2__);

/**
* @name isComposite
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-composite}
*/
setReadOnly( ns, 'isComposite', __var_3__);

/**
* @name isCoprime
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-coprime}
*/
setReadOnly( ns, 'isCoprime', __var_4__);

/**
* @name isEven
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-even}
*/
setReadOnly( ns, 'isEven', __var_5__);

/**
* @name isFinite
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-finite}
*/
setReadOnly( ns, 'isFinite', __var_6__);

/**
* @name isFinitef
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-finitef}
*/
setReadOnly( ns, 'isFinitef', __var_7__);

/**
* @name isInfinite
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-infinite}
*/
setReadOnly( ns, 'isInfinite', __var_8__);

/**
* @name isInfinitef
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-infinitef}
*/
setReadOnly( ns, 'isInfinitef', __var_9__);

/**
* @name isInteger
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-integer}
*/
setReadOnly( ns, 'isInteger', __var_10__);

/**
* @name isnan
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-nan}
*/
setReadOnly( ns, 'isnan', __var_11__);

/**
* @name isnanf
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-nanf}
*/
setReadOnly( ns, 'isnanf', __var_12__);

/**
* @name isNegativeInteger
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-negative-integer}
*/
setReadOnly( ns, 'isNegativeInteger', __var_13__);

/**
* @name isNegativeZero
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-negative-zero}
*/
setReadOnly( ns, 'isNegativeZero', __var_14__);

/**
* @name isNegativeZerof
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-negative-zerof}
*/
setReadOnly( ns, 'isNegativeZerof', __var_15__);

/**
* @name isNonNegativeInteger
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-nonnegative-integer}
*/
setReadOnly( ns, 'isNonNegativeInteger', __var_16__);

/**
* @name isNonPositiveInteger
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-nonpositive-integer}
*/
setReadOnly( ns, 'isNonPositiveInteger', __var_17__);

/**
* @name isOdd
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-odd}
*/
setReadOnly( ns, 'isOdd', __var_18__);

/**
* @name isPositiveInteger
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-positive-integer}
*/
setReadOnly( ns, 'isPositiveInteger', __var_19__);

/**
* @name isPositiveZero
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-positive-zero}
*/
setReadOnly( ns, 'isPositiveZero', __var_20__);

/**
* @name isPositiveZerof
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-positive-zerof}
*/
setReadOnly( ns, 'isPositiveZerof', __var_21__);

/**
* @name isPrime
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-prime}
*/
setReadOnly( ns, 'isPrime', __var_22__);

/**
* @name isProbability
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-probability}
*/
setReadOnly( ns, 'isProbability', __var_23__);

/**
* @name isSafeInteger
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/is-safe-integer}
*/
setReadOnly( ns, 'isSafeInteger', __var_24__);

/**
* @name isPow2Uint32
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/math/base/assert/uint32-is-pow2}
*/
setReadOnly( ns, 'isPow2Uint32', __var_25__);


// EXPORTS //
export default ns;

export { __var_1__ as isEvenInt32, __var_2__ as isOddInt32, __var_3__ as isComposite, __var_4__ as isCoprime, __var_5__ as isEven, __var_6__ as isFinite, __var_7__ as isFinitef, __var_8__ as isInfinite, __var_9__ as isInfinitef, __var_10__ as isInteger, __var_11__ as isnan, __var_12__ as isnanf, __var_13__ as isNegativeInteger, __var_14__ as isNegativeZero, __var_15__ as isNegativeZerof, __var_16__ as isNonNegativeInteger, __var_17__ as isNonPositiveInteger, __var_18__ as isOdd, __var_19__ as isPositiveInteger, __var_20__ as isPositiveZero, __var_21__ as isPositiveZerof, __var_22__ as isPrime, __var_23__ as isProbability, __var_24__ as isSafeInteger, __var_25__ as isPow2Uint32};